module.exports = __webpack_public_path__ + "static/media/icon_ranking.62c0e3d5.svg";